import { render, staticRenderFns } from "./SubirResultado.vue?vue&type=template&id=3db2ae0f&scoped=true&"
import script from "./SubirResultado.vue?vue&type=script&lang=js&"
export * from "./SubirResultado.vue?vue&type=script&lang=js&"
import style0 from "./SubirResultado.vue?vue&type=style&index=0&id=3db2ae0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db2ae0f",
  null
  
)

export default component.exports